import { createContext } from 'react';

type RouteContextType = {
  dispatch: (action: any) => void;
  getState: () => any;
};
const RouteContext = createContext<RouteContextType>({
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  dispatch: () => {},
  getState: () => ({}),
});

export default RouteContext;
